var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4931 9.24042C12.4931 10.6779 11.3278 11.8431 9.89039 11.8431C8.45294 11.8431 7.28766 10.6779 7.28766 9.24042C7.28766 7.80298 8.45294 6.6377 9.89039 6.6377C11.3278 6.6377 12.4931 7.80298 12.4931 9.24042ZM10.4109 9.24042C10.4109 9.52791 10.1779 9.76097 9.89039 9.76097C9.6029 9.76097 9.36984 9.52791 9.36984 9.24042C9.36984 8.95293 9.6029 8.71988 9.89039 8.71988C10.1779 8.71988 10.4109 8.95293 10.4109 9.24042Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89036 16.0078C3.12327 16.0078 0 9.12434 0 9.12434C0 9.12434 2.96711 2.47363 9.89036 2.47363C16.8136 2.47363 19.7807 9.12434 19.7807 9.12434C19.7807 9.12434 16.6575 16.0078 9.89036 16.0078ZM3.84606 7.24611C3.19282 7.92191 2.70524 8.60265 2.37721 9.12501C2.72094 9.6793 3.23532 10.4107 3.92066 11.1357C5.31505 12.6108 7.27773 13.9256 9.89036 13.9256C12.503 13.9256 14.4657 12.6108 15.8601 11.1357C16.5454 10.4107 17.0598 9.6793 17.4035 9.12501C17.0755 8.60265 16.5879 7.92191 15.9347 7.24611C14.583 5.84774 12.617 4.55581 9.89036 4.55581C7.1637 4.55581 5.19776 5.84774 3.84606 7.24611Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenIcon);
export default __webpack_public_path__ + "static/media/eye_open_icon.b18975e0.svg";
export { ForwardRef as ReactComponent };